var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEdit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  className: "edit_svg__icon edit_svg__icon-tabler edit_svg__icon-tabler-edit",
  width: 24,
  height: 24,
  strokeWidth: 2,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  stroke: "none"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M7 7H6a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2v-1"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.385 6.585a2.1 2.1 0 0 0-2.97-2.97L9 12v3h3l8.385-8.415zM16 5l3 3"
})));
export default SvgEdit;